import { useState } from "react"
import { IPrintInvoiceProps } from "./printInvoiceDialog";
import { printInvoice } from "../../../../../../Utilits/utilits";
import { ArmenianFlag, RussianFlag, UnitedStatesFlag } from "../../../../../../Assets/Icons"

export enum InvoiceLangTypes {
    ARMENIAN = 'hy',
    RUSSIAN = 'ru',
    ENGLISH = 'en'
};

interface IInvoiceLangItem {
    icon: string,
    value: InvoiceLangTypes
};

export enum PosPaperSizes {
    SMALL = 58,
    BIG = 80

}


const usePrintInvoiceHook = (props: IPrintInvoiceProps) => {
    const { order, onClose, QR } = props;
    const defaultPOsSize = Number(localStorage.getItem("POS_paper")) || PosPaperSizes.SMALL;
    const [selectedLanguage, setSelectedLanguage] = useState<InvoiceLangTypes>(InvoiceLangTypes.ARMENIAN)
    const [selectedPaperSize, setSelectedPaperSize] = useState<PosPaperSizes>(defaultPOsSize)
    const langItems: IInvoiceLangItem[] = [
        {
            icon: ArmenianFlag,
            value: InvoiceLangTypes.ARMENIAN
        },
        {
            icon: RussianFlag,
            value: InvoiceLangTypes.RUSSIAN
        },
        {
            icon: UnitedStatesFlag,
            value: InvoiceLangTypes.ENGLISH
        }
    ];

    const paperSizes = [
        PosPaperSizes.SMALL,
        PosPaperSizes.BIG
    ];

    const onPrint = () => {
        printInvoice(order, selectedLanguage, selectedPaperSize, QR);
        localStorage.setItem("POS_paper", String(selectedPaperSize));
        onClose()
    };

    return {
        langItems,
        paperSizes,
        selectedLanguage,
        selectedPaperSize,
        onPrint,
        setSelectedLanguage,
        setSelectedPaperSize,
    }
};

export default usePrintInvoiceHook